export enum EntityTypeId {
	Company = 'COMPANY',
	Contact = 'CONTACT',
	Deal = 'DEAL',
	Lead = 'LEAD',
}
